import { requestAPI } from 'api/AdminEndpointsAPI';
import { get, isString } from 'lodash';
import { addNegativeToast, addPositiveToast, removeAllToasts } from 'modules/toastContainer';
import { call, put, takeLatest } from 'redux-saga/effects';
import { addToRootSaga } from 'store';
import * as actionTypes from './actionTypes';
import { fetchResponse } from './actions';

/**
 * postRequest
 * Saga for positng the request.
 * @param { Object } props: Fetch props containing the feature flag name.
 * @return { void }
 */
export default function* postRequestSaga({ request }) {
  try {
    yield put(removeAllToasts());
    const response = yield call(requestAPI, request);
    const { data } = response;
    const dataMsg = data || `Successful ${request.method} from route: ${request.route}`;
    const msg = isString(dataMsg) ? dataMsg : JSON.stringify(data);

    // put response in Redux store, keyed by route
    yield put(fetchResponse({ response, route: request?.route }));

    // add response to callback functions if provided
    const { actions = [] } = request;
    const formattedActions = actions.map((action) => ({
      ...action,
      onClick: () => action?.onClick(response),
    }));

    yield put(
      addPositiveToast(msg, {
        actions: formattedActions,
        noDelay: actions.length > 0,
      }),
    );
  } catch (error) {
    const responseBody = get(error, 'response.data');
    const statusText = get(error, 'response.statusText', 'Something went wrong');
    /* Some responses are a helpful message, others are the default
     * Play framework error pages; show the helpful message when possible.
     */
    const msg = responseBody && !/<!DOCTYPE html>/.test(responseBody) ? responseBody : statusText;
    yield put(addNegativeToast(msg));
  }
}

addToRootSaga([takeLatest(actionTypes.SEND_POST_REQUEST, postRequestSaga)]);
